import { FC, Suspense } from 'react';
import { Modal, Drawer, View, Flex, Text, Icon } from '../Element';
import useDeviceSize from '../../hooks/useDeviceSize';
import { responsiveModalDrawerStyle } from './ResponsiveModalDrawer.style';
import Loading from '../Loading';

type properties = {
  children: JSX.Element[] | JSX.Element;
  isOpen: boolean;
  toggleOpen: Function;
  title: string;

  backEnabled?: boolean;
  closeEnabled?: boolean;

  onClose?: Function;
  onBack?: Function;
};

export const ResponsiveModalDrawer: FC<properties> = (props) => {
  const device = useDeviceSize();
  const style = responsiveModalDrawerStyle(device);

  const Header = ({ title }: { title: string }) => (
    <Flex vertical={false} justify="space-between" align="center" style={style.headerContainer}>
      <Flex vertical={false} align="center" justify="space-between">
        {props.backEnabled ? (
          <Icon size={24} style={style.icon} icon="back" onClick={() => props.onBack && props.onBack()} />
        ) : (
          <></>
        )}
        <View style={style.header}>{title}</View>
      </Flex>
      {props.closeEnabled ? (
        <Icon size={24} style={style.icon} icon="cancel" onClick={() => props.onClose && props.onClose()} />
      ) : (
        <></>
      )}
    </Flex>
  );

  return (
    <Suspense>
      {device.isDesktop ? (
        <Modal
          title={<Header title={props.title} />}
          open={props.isOpen}
          onCancel={() => {
            props.onClose && props.onClose();
            props.toggleOpen(false);
          }}
          onOk={() => {}}
          closeIcon={false}
          footer={<></>}
        >
          {props.children}
        </Modal>
      ) : (
        <Drawer
          title={<Header title={props.title} />}
          placement="bottom"
          open={props.isOpen}
          closable={false}
          onClose={() => {
            props.onClose && props.onClose();
            props.toggleOpen(false);
          }}
          width="100%"
          height="auto"
        >
          {props.children}
        </Drawer>
      )}
    </Suspense>
  );
};
